module.exports = __webpack_public_path__ + "static/media/lc.5ad24b4c.svg";